import { createFileRoute } from '@tanstack/react-router'
import { OkrDashboard } from 'pages/okrDashboard/OkrDashboard'

export const Route = createFileRoute('/okr-dashboard')({
  component: OkrDashboard,
  staticData: {
    title: 'OKR Dashboard',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: true,
    },
  },
})
